var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var AuthWidget = function () {
            function AuthWidget(params) {
                _classCallCheck(this, AuthWidget);

                this.links = params.links ? params.links : null;
                this.labels = params.labels ? params.labels : null;
                this.isFromBooking = params.isFromBooking ? params.isFromBooking : false;
                this.isPartnerAuth = params.isPartnerAuth ? params.isPartnerAuth : false;
                this.isPromoCodeAuth = params.isPromoCodeAuth ? params.isPromoCodeAuth : false;
                this.isFirstAuth = false;
                this.authPlace = 'booking';
                this.formType = params.type ? params.type : 'unknown';
                this.formPlace = params.formPlace ? params.formPlace : 'unknown';

                this.mask = null;
                this.resendCounterIntervalId = null;

                this.initPhoneMask();

                this.handlers();
                this.codeInputsHandler();

                if (this.formType !== 'before-booking-modal' && this.formType !== 'modal') {
                    this.sendOpenEvent();
                }
            }

            _createClass(AuthWidget, [{
                key: "initPhoneMask",
                value: function initPhoneMask() {
                    var mask = document.querySelector('#js-phone-inputmask');
                    var group = mask.closest('.js-input-group');
                    var defaultMask = group.querySelector('.code').dataset.mask;
                    this.mask = IMask(mask, {
                        mask: defaultMask ? defaultMask.replace(/9/g, '0') : '(000) 000-00-00',
                        definitions: {
                            X: {
                                mask: '0',
                                displayChar: 'X',
                                placeholderChar: '#'
                            }
                        },
                        lazy: false,
                        overwrite: 'shift'
                    });
                }
            }, {
                key: "handlers",
                value: function handlers() {
                    var _this = this;

                    /** Этой хуйне тут не место надо куда то вынести потом **/
                    eventDispatcher.addEvent('click', '.js-modal-toggle', function () {
                        window.brxTracking.setYaEvent('DesktopBookOnline.ModalCall');
                    });

                    eventDispatcher.addAllEvent('keydown', '#js-phone-inputmask', function (event) {
                        // Проверяем, была ли нажата клавиша Enter
                        if (event.key === 'Enter') {
                            // Получаем ссылку на кнопку
                            var btnSendCode = document.querySelector('.js-send-code');
                            // Вызываем метод click() для кнопки
                            btnSendCode.click();
                        }
                    });

                    eventDispatcher.addAllEvent('change', '#s_countryPhoneCode', function (event) {
                        var target = event.target;
                        var select = target.closest('.pseudo-select');
                        var option = select.querySelector('.options div[data-value="' + target.value + '"]');

                        if (option) {

                            var phone = document.querySelector('.auth-form__phone');
                            if (phone) {
                                phone.value = '';
                            }

                            _this.mask.updateOptions({
                                mask: option.querySelector('.code').dataset.mask.replace(/9/g, '0')
                            });
                            _this.mask.updateValue();
                        }
                    });

                    eventDispatcher.addAllEvent('click', '.js-send-code', function (e) {
                        eventDispatcher.dispatchEvent('toggleBtnLoading', {
                            target: e.currentTarget,
                            isShow: true
                        });

                        window.brxTracking.setYaEvent('BookOnlineAuthModal.NumberSent');

                        if (_this.isPartnerAuth) {
                            _this.sendAuthRequest({
                                phone: document.querySelector('.auth-form__phone').value,
                                code: document.querySelector('#s_countryPhoneCode').value,
                                source: document.querySelector('.auth-partners-page').dataset.source,
                                companyId: document.querySelector('.auth-partners-page').dataset.id
                            });
                        } else {
                            var codeValue = document.querySelector('#s_countryPhoneCode').value;
                            var code = codeValue.trim().replace(/^[_+]+|[_+]+$/g, '');

                            _this.sendAuthRequest({
                                phone: document.querySelector('.auth-form__phone').value,
                                code: code
                            });
                        }
                    });

                    eventDispatcher.addAllEvent('click', '.js-login', function (e) {
                        eventDispatcher.dispatchEvent('toggleBtnLoading', {
                            target: document.querySelector('.js-btn-resend-code'),
                            isShow: true,
                            content: '<span class="spinner-loader"></span>'
                        });

                        var inputElements = document.querySelectorAll('.js-input-code-item');
                        var values = Array.from(inputElements).map(function (input) {
                            var parsedValue = parseInt(input.value, 10);

                            // Проверяем, является ли значение числом и не пустым
                            if (!isNaN(parsedValue)) {
                                return parsedValue;
                            } else {
                                return null; // Если не число или пусто, добавляем null в массив
                            }
                        });

                        values = values.filter(function (value) {
                            return value !== null;
                        });

                        var combinedValue = values.join('');

                        var obPage = document.querySelector('.online-booking-page');

                        if (_this.isPromoCodeAuth) {
                            _this.authPlace = 'promo-code';
                        }

                        var loginData = {
                            phone: document.querySelector('.auth-form__phone').value,
                            code: document.querySelector('#s_countryPhoneCode').value,
                            smsCode: combinedValue,
                            authPlace: _this.authPlace
                        };

                        if (obPage) {
                            loginData.tourId = obPage.dataset.id;
                        }

                        _this.sendLoginRequest(loginData);
                    });

                    eventDispatcher.addAllEvent('click', '.js-btn-resend-code', function (event) {
                        var target = event.currentTarget;
                        var element = document.querySelector('.js-send-code');
                        var clickEvent = new Event('click');

                        if (target.disabled || !element) {
                            return;
                        }

                        target.disabled = true;

                        element.dispatchEvent(clickEvent);

                        _this.codeResendCounter(target);
                    });

                    eventDispatcher.addAllEvent('click', '.js-btn-change-phone', function (event) {
                        var target = event.target;
                        var panelPhone = document.querySelector('.auth-phone-panel');
                        var panelCode = document.querySelector('.auth-code-panel');
                        panelPhone.classList.remove('hide');
                        panelCode.classList.add('hide');
                    });

                    eventDispatcher.addEvent('click', '.js-registration-partner', function (e) {
                        eventDispatcher.dispatchEvent('toggleBtnLoading', {
                            target: e.currentTarget,
                            isShow: true
                        });

                        var params = {
                            firstName: document.querySelector('[name="firstName"]').value,
                            secondName: document.querySelector('[name="secondName"]').value,
                            iin: document.querySelector('[name="iin"]').value
                        };

                        _this.sendRegistrationRequest(params);
                    });

                    eventDispatcher.addEvent('click', '.js-btn-after-auth', function (e) {
                        window.location.href = _this.links.afterPartnerAuthLink;
                    });

                    eventDispatcher.addAllEvent('click', '#halyk-sing-in', function () {
                        _this.sendAnalyticEvent('click_login_halyk_id');
                    });
                }
            }, {
                key: "codeInputsHandler",
                value: function codeInputsHandler() {
                    var _this2 = this;

                    var inputs = document.querySelectorAll('.js-input-code-item');
                    var loginBtn = document.querySelector('.js-login');

                    // Очистка всех инпутов при открытии формы
                    inputs.forEach(function (input) {
                        return input.value = '';
                    });

                    inputs.forEach(function (input, index) {

                        // Разрешаем только цифры
                        input.addEventListener('keydown', function (event) {
                            _this2.clearCodeError();
                            var isNumber = /^[0-9]$/.test(event.key);
                            var isBackspace = event.key === 'Backspace';
                            var isTab = event.key === 'Tab';

                            // TAB пропускаем
                            if (isTab) return;

                            // Цифры — ок
                            if (isNumber) {
                                input.value = ''; // При перезаписи вводим только 1 цифру
                                return;
                            }

                            // Backspace — особая логика
                            if (isBackspace) {
                                event.preventDefault();

                                if (input.value === '' && index > 0) {
                                    inputs[index - 1].focus();
                                    inputs[index - 1].value = '';
                                } else {
                                    input.value = '';
                                }
                                return;
                            }

                            // Все остальные символы запрещаем
                            event.preventDefault();
                        });

                        // Автопереход вперёд
                        input.addEventListener('input', function () {
                            _this2.clearCodeError();
                            var value = input.value.replace(/\D/g, '');
                            input.value = value;

                            if (value && index < inputs.length - 1) {
                                inputs[index + 1].focus();
                            }

                            // Если последний и всё заполнено — кликаем вход
                            if (index === inputs.length - 1) {
                                var allFilled = Array.from(inputs).every(function (inp) {
                                    return inp.value !== '';
                                });
                                if (allFilled && loginBtn) {
                                    loginBtn.click();
                                }
                            }
                        });

                        // Вставка 6-значного кода
                        input.addEventListener('paste', function (event) {
                            event.preventDefault();

                            var pasted = event.clipboardData.getData('text').replace(/\D/g, '') // только цифры
                            .slice(0, inputs.length); // максимум 6 цифр

                            if (!pasted.length) return;

                            // Заполняем ВСЕГДА начиная с 0-го индекса
                            inputs.forEach(function (inp, i) {
                                inp.value = pasted[i] ? pasted[i] : '';
                            });

                            // Если вставки хватило на все поля → жмём "войти"
                            var allFilled = inputs.length === pasted.length;

                            if (allFilled && loginBtn) {
                                loginBtn.click();
                            } else {
                                // Если что-то осталось пустым — фокусируемся на первом пустом
                                var firstEmpty = Array.from(inputs).find(function (inp) {
                                    return inp.value === '';
                                });
                                if (firstEmpty) {
                                    firstEmpty.focus();
                                }
                            }
                        });
                    });

                    // Фокус на первый элемент
                    inputs[0].focus();
                }
            }, {
                key: "clearCodeError",
                value: function clearCodeError() {
                    var hint = document.querySelector('.js-panel-code-hint');
                    var list = document.querySelector('.js-auth-input-list');

                    if (hint && hint.classList.contains('error')) {
                        hint.classList.remove('error');
                        hint.textContent = this.labels.codePanel.hint;
                    }
                    if (list && list.classList.contains('error')) {
                        list.classList.remove('error');
                    }
                }
            }, {
                key: "sendAuthRequest",
                value: function sendAuthRequest(params) {
                    var _this3 = this;

                    var hint = document.querySelector('.js-phone-panel-hint');
                    hint.classList.remove('error');

                    if (!this.isPartnerAuth) {
                        hint.textContent = this.labels.phonePanel.hint;
                    }

                    var inputGroup = document.querySelector('.js-input-group');
                    inputGroup.classList.remove('error');

                    ajax.post(this.links.authLink, { params: params }, function (data) {
                        eventDispatcher.dispatchEvent('toggleBtnLoading', {
                            target: document.querySelector('.js-send-code'),
                            isShow: false
                        });

                        if (data.success) {
                            var panelPhone = document.querySelector('.auth-phone-panel');
                            var panelCode = document.querySelector('.auth-code-panel');
                            var title = panelCode.querySelector('.js-title');
                            title.innerHTML = _this3.labels.codePanel.title + ': +' + params.code + ' ' + params.phone;
                            panelPhone.classList.add('hide');
                            panelCode.classList.remove('hide');
                            var codeInputs = document.querySelectorAll('.js-input-code-item');
                            codeInputs[0].focus();
                            _this3.codeResendCounter(document.querySelector('.js-btn-resend-code'));
                            _this3.sendAnalyticEvent('next_step_to_book_number_sent');
                        } else {
                            var errors = Object.values(data.errors);
                            if (errors.length > 0) {
                                hint.classList.add('error');
                                hint.textContent = errors[0];
                                inputGroup.classList.add('error');
                            }
                        }
                    });
                }
            }, {
                key: "sendLoginRequest",
                value: function sendLoginRequest(data) {
                    var _this4 = this;

                    var hint = document.querySelector('.js-panel-code-hint');
                    hint.classList.remove('error');

                    if (!this.isPartnerAuth) {
                        hint.textContent = this.labels.codePanel.hint;
                    }

                    var inputList = document.querySelector('.js-auth-input-list');
                    inputList.classList.remove('error');

                    ajax.post(this.links.loginLink, { params: data }, function (data) {
                        if (_this4.isPartnerAuth) {
                            _this4.authPlace = 'partner-page';
                        }

                        if (data.success) {
                            _this4.sendAnalyticEvent('auth_status', {
                                'Success Auth': true
                            });

                            if (data.responseData && data.responseData.link) {
                                window.location.href = data.responseData.link;
                                return;
                            }

                            if (_this4.isPartnerAuth) {
                                if (_this4.isFirstAuth) {
                                    _this4.showRegistrationForm();
                                } else {
                                    _this4.showSuccessContent();
                                }
                            } else if (_this4.authPlace === 'actual-price-modal-booking') {
                                _this4.handleActualPriceModalBookingAuthSuccess();
                            } else {
                                _this4.addHotelToWishlist(function () {
                                    _this4.redirectLink();
                                });
                            }
                        } else {
                            var errors = Object.values(data.errors);
                            _this4.sendAnalyticEvent('auth_status', {
                                'Success Auth': false
                            });
                            if (errors.length > 0) {
                                hint.classList.add('error');
                                hint.textContent = errors[0];

                                inputList.classList.add('error');
                            }

                            eventDispatcher.dispatchEvent('toggleBtnLoading', {
                                target: document.querySelector('.js-btn-resend-code'),
                                isShow: false
                            });
                        }
                    });
                }
            }, {
                key: "redirectLink",
                value: function redirectLink() {
                    var urlParams = new URLSearchParams(window.location.search);
                    var backUrl = urlParams.get('backUrl');

                    if (this.isPromoCodeAuth) {
                        // превращаем параметры в строку
                        var queryString = urlParams.toString();
                        var baseUrl = this.links.afterPromoCodeAuthLink;

                        // аккуратно добавляем ? или &
                        window.location.href = queryString ? "" + baseUrl + (baseUrl.includes('?') ? '&' : '?') + queryString : baseUrl;
                    } else {
                        window.location.href = this.links.afterLoginRedirectLink;
                    }
                }
            }, {
                key: "handleActualPriceModalBookingAuthSuccess",
                value: function handleActualPriceModalBookingAuthSuccess() {
                    if (window.modals && window.modals.auth && typeof window.modals.auth.hide === 'function') {
                        window.modals.auth.hide();
                    }

                    eventDispatcher.dispatchEvent('authSuccessActualPriceModalBooking');
                }
            }, {
                key: "sendRegistrationRequest",
                value: function sendRegistrationRequest(params) {
                    var _this5 = this;

                    this.clearRegistrationErrors();

                    eventDispatcher.dispatchEvent('toggleBtnLoading', {
                        target: document.querySelector('.js-registration-partner'),
                        isShow: false
                    });

                    ajax.post(this.links.registrationLink, { params: params }, function (data) {
                        if (data.errors) {
                            _this5.displayErrors(data.errors);
                        } else {
                            _this5.showSuccessContent();
                        }
                    });
                }
            }, {
                key: "codeResendCounter",
                value: function codeResendCounter(element) {
                    var _this6 = this;

                    if (!element) {
                        return;
                    }

                    element.innerHTML = this.labels.controls.resendCodeThrough + '<span id="code-counter">:<span class="value">59</span></span>';
                    element.disabled = true;

                    var counterElement = document.getElementById('code-counter');

                    // Проверяем, есть ли сохраненное время начала в localStorage
                    var startTime = localStorage.getItem('startTimeCodeCounter');

                    // Если время начала не сохранено или прошло более 60 секунд, начинаем заново
                    if (!startTime || Date.now() - startTime > 60000) {
                        startTime = Date.now();
                        localStorage.setItem('startTimeCodeCounter', startTime.toString());
                    }

                    // Получаем разницу между текущим временем и временем начала в секундах
                    var initialDiffInSeconds = Math.floor((Date.now() - startTime) / 1000);

                    var counterValue = 59 - initialDiffInSeconds;

                    // Если счетчик становится отрицательным, устанавливаем его в 0
                    if (counterValue < 0) {
                        counterValue = 0;
                    }

                    var value = counterElement.querySelector('.value');
                    value.textContent = counterValue;

                    if (this.resendCounterIntervalId) {
                        clearInterval(this.resendCounterIntervalId);
                    }

                    this.resendCounterIntervalId = setInterval(function () {
                        counterValue--;

                        value.textContent = counterValue;

                        if (counterValue === 0) {
                            clearInterval(_this6.resendCounterIntervalId);
                            _this6.resendCounterIntervalId = null;
                            element.disabled = false;
                            element.querySelector('#code-counter').remove();
                            element.textContent = _this6.labels.controls.resendCode;
                        }
                    }, 1000);
                }
            }, {
                key: "showSuccessContent",
                value: function showSuccessContent() {
                    var companyName = document.querySelector('.auth-success-company-name');
                    companyName.textContent = document.querySelector('.auth-partners-page').dataset.name;

                    var panelCode = document.querySelector('.auth-code-panel');
                    panelCode.classList.add('hide');

                    var successAuth = document.querySelector('.auth-success-content');
                    successAuth.classList.remove('hide');

                    var registration = document.querySelector('.auth-partners-registration-form');
                    registration.classList.add('hide');
                }
            }, {
                key: "showRegistrationForm",
                value: function showRegistrationForm() {
                    var panelCode = document.querySelector('.auth-code-panel');
                    panelCode.classList.add('hide');
                    var registration = document.querySelector('.auth-partners-registration-form');
                    registration.classList.remove('hide');
                    if (this.authPlace === 'one-click-popup') {
                        // для формы забронировать в 1 клик скрываем авторизацию через halyk id
                        var halykAuthButton = document.querySelector('.default-halyk-sing-in-button');
                        if (halykAuthButton) {
                            halykAuthButton.classList.add('hide');
                        }
                    }
                }
            }, {
                key: "clearRegistrationErrors",
                value: function clearRegistrationErrors() {
                    var errorElements = document.querySelectorAll('.error-message');
                    errorElements.forEach(function (element) {
                        return element.remove();
                    });

                    document.querySelectorAll('.form-group').forEach(function (e) {
                        e.classList.remove('error');
                    });
                }
            }, {
                key: "displayErrors",
                value: function displayErrors(errors) {
                    if (errors.firstName) {
                        this.showError(document.querySelector('[name="firstName"]'), errors.firstName);
                    }
                    if (errors.secondName) {
                        this.showError(document.querySelector('[name="secondName"]'), errors.secondName);
                    }
                    if (errors.iin) {
                        this.showError(document.querySelector('[name="iin"]'), errors.iin);
                    }
                }
            }, {
                key: "showError",
                value: function showError(inputElement, errorMessage) {
                    // Создать элемент для отображения ошибки
                    var errorElement = document.createElement('div');
                    errorElement.className = 'error-message';
                    errorElement.textContent = errorMessage;

                    // Вставить элемент после поля ввода
                    inputElement.parentNode.insertBefore(errorElement, inputElement.nextSibling);

                    inputElement.closest('.form-group').classList.add('error');
                }
            }, {
                key: "addHotelToWishlist",
                value: function addHotelToWishlist() {
                    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                    var urlParams = new URLSearchParams(window.location.search);
                    var isFromFindTours = urlParams.get('from') === 'find-tours';
                    var isFromHotelWishlist = urlParams.get('fromHotelWishlist') === '1';
                    var urlHotelId = urlParams.get('hotelId');
                    var sessionHotelId = sessionStorage.getItem('wishlistAuthHotelId');
                    var hotelId = isFromFindTours || isFromHotelWishlist || sessionHotelId ? urlHotelId || sessionHotelId : null;

                    if (!hotelId) {
                        if (typeof callback === 'function') {
                            callback();
                        }

                        return;
                    }

                    sessionStorage.removeItem('wishlistAuthHotelId');

                    var addWishlistHotelLink = '/new/wishlist/add-wishlist-hotel';
                    var isFinished = false;
                    var finish = function finish() {
                        if (isFinished) {
                            return;
                        }

                        isFinished = true;

                        if (typeof callback === 'function') {
                            callback();
                        }
                    };

                    var fallbackTimer = setTimeout(finish, 3000);

                    ajax.post(addWishlistHotelLink + "?hotelId=" + hotelId, {}, function (response) {
                        if (isFinished) {
                            return;
                        }

                        clearTimeout(fallbackTimer);

                        if (response && response.success) {
                            sessionStorage.setItem('wishlistAuthSuccessHotelId', hotelId);
                        }

                        finish();
                    });
                }
            }, {
                key: "sendOpenEvent",
                value: function sendOpenEvent() {
                    this.sendAnalyticEvent('auth_form_open');
                }
            }, {
                key: "sendAnalyticEvent",
                value: function sendAnalyticEvent(eventName) {
                    var eventProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                    eventProperties = Object.assign({
                        'Form type': this.formType,
                        'Form place': this.formPlace
                    }, eventProperties);
                    window.brxTracking.sendAnalyticsEvent(eventName, eventProperties);
                }
            }]);

            return AuthWidget;
        }();

        window.AuthWidget = AuthWidget;
    }, {}] }, {}, [1]);